import React from "react";
import { Link } from "react-router-dom";
import { useLanguage } from "../context/LanguageContext";
import "./Footer.css";

function InstagramIcon() {
  return (
    <svg
      viewBox="0 0 24 24"
      width="21"
      height="21"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <rect
        x="3"
        y="3"
        width="18"
        height="18"
        rx="5"
      />
      <circle
        cx="12"
        cy="12"
        r="4"
      />
      <circle
        cx="17.5"
        cy="6.5"
        r="1"
        fill="currentColor"
        stroke="none"
      />
    </svg>
  );
}

function WhatsAppIcon() {
  return (
    <svg
      viewBox="0 0 24 24"
      width="21"
      height="21"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <path d="M20.5 11.8a8.5 8.5 0 0 1-12.6 7.4L3.5 20.5l1.3-4.3A8.5 8.5 0 1 1 20.5 11.8Z" />
      <path d="M8.4 8.1c.2-.5.5-.5.8-.5h.4c.1 0 .3 0 .4.4l.8 1.9c.1.3.1.5-.1.7l-.6.7c-.2.2-.2.4 0 .7.5.9 1.2 1.6 2.1 2.1.3.2.5.2.7 0l.8-1c.2-.2.4-.3.7-.2l2 .9c.3.1.5.2.5.4 0 .2 0 1.1-.5 1.7-.5.6-1.4 1.1-2 1.1-.5 0-1.2-.1-2.7-.8-1.6-.7-2.8-1.8-3.8-3.1-1-1.2-1.7-2.6-1.7-3.8 0-.7.2-1.3.5-1.8Z" />
    </svg>
  );
}

function PhoneIcon() {
  return (
    <svg
      viewBox="0 0 24 24"
      width="21"
      height="21"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.8 19.8 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6A19.8 19.8 0 0 1 2.12 4.18 2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.12.9.33 1.78.62 2.63a2 2 0 0 1-.45 2.11L8 9.73a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.85.29 1.73.5 2.63.62A2 2 0 0 1 22 16.92Z" />
    </svg>
  );
}

function LocationIcon() {
  return (
    <svg
      viewBox="0 0 24 24"
      width="21"
      height="21"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <path d="M20 10c0 5-8 12-8 12S4 15 4 10a8 8 0 1 1 16 0Z" />
      <circle
        cx="12"
        cy="10"
        r="2.5"
      />
    </svg>
  );
}

function MailIcon() {
  return (
    <svg
      viewBox="0 0 24 24"
      width="21"
      height="21"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <rect
        x="3"
        y="5"
        width="18"
        height="14"
        rx="2"
      />
      <path d="m3 7 9 6 9-6" />
    </svg>
  );
}

function Footer() {
  const { language } = useLanguage();

  const text = {
    en: {
      description:
        "Premium and reliable car rental for your journey across Albania.",

      navigation: "Navigation",

      home: "Home",
      cars: "Cars & Prices",
      booking: "Booking",
      contact: "Contact & Socials",

      contactTitle: "Contact",

      location:
        "Rinas, Tirana, Albania",

      follow: "Follow Us",

      rights:
        "All rights reserved.",
    },

    sq: {
      description:
        "Makina me qira premium dhe të besueshme për udhëtimin tënd në Shqipëri.",

      navigation: "Navigimi",

      home: "Kryefaqja",
      cars: "Makinat & Çmimet",
      booking: "Rezervimi",
      contact:
        "Kontakt & Rrjetet Sociale",

      contactTitle: "Kontakt",

      location:
        "Rinas, Tiranë, Shqipëri",

      follow: "Na Ndiq",

      rights:
        "Të gjitha të drejtat e rezervuara.",
    },
  };

  const t =
    text[language] || text.en;

  return (
    <footer className="site-footer">
      <div className="footer-wrapper">
        <div className="footer-grid">
          {/* BRAND */}

          <div className="footer-brand-section">
            <Link
              to="/"
              className="footer-brand"
            >
              <div className="footer-logo">
                AR
              </div>

              <div>
                <div className="footer-brand-title">
                  AutoRent Albania
                </div>

                <div className="footer-brand-subtitle">
                  Drive Albania your way
                </div>
              </div>
            </Link>

            <p className="footer-description">
              {t.description}
            </p>

            <div className="footer-social-icons">
              <a
                href="https://www.instagram.com/autorent.albania?igsi=NTZzNDBiMjJ4YTRr&utm_source=qr"
                target="_blank"
                rel="noopener noreferrer"
                className="footer-social-circle"
                aria-label="Instagram"
              >
                <InstagramIcon />
              </a>

              <a
                href="https://wa.me/355697555461"
                target="_blank"
                rel="noopener noreferrer"
                className="footer-social-circle"
                aria-label="WhatsApp"
              >
                <WhatsAppIcon />
              </a>
            </div>
          </div>

          {/* NAVIGATION */}

          <div className="footer-column">
            <h3>
              {t.navigation}
            </h3>

            <Link to="/">
              {t.home}
            </Link>

            <Link to="/cars">
              {t.cars}
            </Link>

            <Link to="/booking">
              {t.booking}
            </Link>

            <Link to="/contact">
              {t.contact}
            </Link>
          </div>

          {/* CONTACT */}

          <div className="footer-column footer-contact-column">
            <h3>
              {t.contactTitle}
            </h3>

            <a
              href="tel:+355697555461"
              className="footer-contact-row"
            >
              <span className="footer-contact-icon">
                <PhoneIcon />
              </span>

              <span>
                +355 69 755 5461
              </span>
            </a>

            <a
              href="https://wa.me/355697555461"
              target="_blank"
              rel="noopener noreferrer"
              className="footer-contact-row"
            >
              <span className="footer-contact-icon">
                <WhatsAppIcon />
              </span>

              <span>
                WhatsApp
              </span>
            </a>

            <a
              href="https://www.google.com/maps/search/?api=1&query=41.422878,19.712574"
              target="_blank"
              rel="noopener noreferrer"
              className="footer-contact-row"
            >
              <span className="footer-contact-icon">
                <LocationIcon />
              </span>

              <span>
                {t.location}
              </span>
            </a>

            <a
              href="mailto:info@rentalalbania.group"
              className="footer-contact-row"
            >
              <span className="footer-contact-icon">
                <MailIcon />
              </span>

              <span>
                info@rentalalbania.group
              </span>
            </a>
          </div>

          {/* SOCIALS */}

          <div className="footer-column">
            <h3>
              {t.follow}
            </h3>

            <a
              href="https://www.instagram.com/autorent.albania?igsi=NTZzNDBiMjJ4YTRr&utm_source=qr"
              target="_blank"
              rel="noopener noreferrer"
              className="footer-social-row"
            >
              <span className="footer-contact-icon">
                <InstagramIcon />
              </span>

              <span>
                Instagram
              </span>
            </a>

            <a
              href="https://wa.me/355697555461"
              target="_blank"
              rel="noopener noreferrer"
              className="footer-social-row"
            >
              <span className="footer-contact-icon">
                <WhatsAppIcon />
              </span>

              <span>
                WhatsApp
              </span>
            </a>
          </div>
        </div>

        {/* BOTTOM */}

        <div className="footer-bottom">
          <span>
            © {new Date().getFullYear()}{" "}
            AutoRent Albania.{" "}
            {t.rights}
          </span>

          <span className="footer-domain">
            rentalalbania.group
          </span>
        </div>
      </div>
    </footer>
  );
}

export default Footer;